import { render, staticRenderFns } from "./RemesasTabContent.vue?vue&type=template&id=be8fb8cc&scoped=true"
import script from "./RemesasTabContent.vue?vue&type=script&lang=js"
export * from "./RemesasTabContent.vue?vue&type=script&lang=js"
import style0 from "./RemesasTabContent.vue?vue&type=style&index=0&id=be8fb8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8fb8cc",
  null
  
)

export default component.exports